import styled from 'styled-components';

export const HeaderStyles = styled.header`
  .headline {
    font-family: 'Ubuntu', sans-serif;
    font-size: 24px;
    font-weight: 700;
    border-left: 4px solid #cf1a17;
    padding-left: 16px;
    margin-bottom: 20px;
  }

  .key-text-wrap,
  .key-colours-wrap {
    display: flex;
    width: 100%;
  }

  .key-text {
    font-family: 'Ubuntu';
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
    width: 6.66%;
    padding-left: 2px;
  }

  .key-text-dbl {
    font-family: 'Ubuntu';
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
    width: 13.33%;
    text-align: right;
    padding-right: 2px;
  }

  .key-colour {
    height: 16px;
    width: 6.666%;
  }

  .key-wrap {
    margin-bottom: 20px;
  }

  .key-heading {
    text-align: center;
    padding-top: 10px;
    font-weight: 600;
  }
`;
